import styles from "./styles.module.scss"
import PriceTagsOutline from "~icons/eva/pricetags-outline"
import BulbOutline from "~icons/eva/bulb-outline"
import { colors } from "@theme/colors"

const variants = {
  priceDrop: {
    icon: PriceTagsOutline,
    text: "Price drop",
    backgroundColor: colors.tagsGreenBackground,
    textColor: colors.tagsGreenText,
  },
  agentPick: {
    icon: BulbOutline,
    text: "Advisor pick",
    backgroundColor: colors.tagsAgentPickBackground,
    textColor: colors.tagsAgentPickText,
  },
}

const Tag = ({ variant }: { variant: keyof typeof variants }) => {
  const selectedVariant = variants[variant]

  if (!selectedVariant) {
    return null
  }

  return (
    <div
      className={styles.iconContainer}
      style={{ backgroundColor: selectedVariant.backgroundColor }}
    >
      <selectedVariant.icon style={{ color: selectedVariant.textColor, width: 16, height: 16 }} />
      <span className={styles.tagText} style={{ color: selectedVariant.textColor }}>
        {selectedVariant.text}
      </span>
    </div>
  )
}

export default Tag
